export const PERMISSION_ACCESS = {
    NoAccess: "no-access",
    ReadOnly: "read-only",
    ReadWrite: "read-write",
} as const;

export type PermissionAccess = (typeof PERMISSION_ACCESS)[keyof typeof PERMISSION_ACCESS];

const PERMISSION_ACCESS_VALUES = new Set<string>(Object.values(PERMISSION_ACCESS));

export function isPermissionAccess(value: string): value is PermissionAccess {
    return PERMISSION_ACCESS_VALUES.has(value);
}

export const ROLE_KEY = {
    ExpenseAdmin: "expense_admin",
    CompanyAccountingApprover: "company_accounting_approver",
    GroupAccountingApprover: "group_accounting_approver",
    AccountingAdmin: "accounting_admin",
    Approver: "approver",
} as const;

export type RoleKey = (typeof ROLE_KEY)[keyof typeof ROLE_KEY];

export interface PermissionModule {
    id: string;
    label: string;
    children?: PermissionModule[];
}

export interface PermissionRole {
    id: string;
    roleKey?: string;
    label: string;
    subtitle?: string;
}

export interface ModulePermissionCell {
    moduleId: string;
    roleId: string;
    access: PermissionAccess | null;
    editable: boolean;
}

/** Mirrors the GraphQL `GroupSummary { groupId: ID!, groupName: String }` shape. */
export interface GroupRef {
    groupId: string;
    groupName: string | null;
}

export interface PermissionUser {
    id: string;
    name: string;
    initials?: string;
    emailId?: string | null;
}

export interface RoleAssignment {
    roleId: string;
    description: string;
    userIds: string[];
}
